module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
    /*
      PF-2605. Hide this property for now. This should be reactivated later on during the process-
      Please DON'T REMOVE THIS.
    */

/*var checkTablet = "";
var checkPhone = "";
if(gridData[selectedRowId].attributes.deviceTablet.isHidden) {
    checkTablet = 'checked="true" ';}

if(gridData[selectedRowId].attributes.devicePhone.isHidden) {
    checkPhone = 'checked="true" ';}*/

    ; __append("\r\n\r\n<!--div class=\"row\">\r\n    <div class=\"col-md-12 nopadding\">\r\n        <input id=\"isHiddenTablet\" type=\"checkbox\" name=\"isHiddenTablet\"  ")
    ; __append(escapeFn(/*checkTablet*/))
    ; __append(">  Hide on Tablet\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding\">\r\n        <input id=\"isHiddenPhone\" type=\"checkbox\" name=\"isHiddenPhone\"  ")
    ; __append(escapeFn( /*checkPhone*/ ))
    ; __append(">  Hide on Phone\r\n    </div>\r\n</div-->\r\n")
  }
  return __output;

}